import React from 'react';
import { DownloadIcon } from 'lucide-react';
import { BRAND } from '../data/brand';
import { datasetFilename, downloadFile, Row, toCsv } from '../utils/download';
interface DownloadButtonsProps {
  name: string;
  getRows: () => Row[];
  sourceNote?: string;
}
export function DownloadButtons({
  name,
  getRows,
  sourceNote
}: DownloadButtonsProps) {
  const csv = () => downloadFile(datasetFilename(name, 'csv'), toCsv(getRows()), 'text/csv;charset=utf-8');
  const json = () => downloadFile(datasetFilename(name, 'json'), JSON.stringify({
    publisher: BRAND.domain,
    dataset: name,
    generated: new Date().toISOString(),
    note: sourceNote ?? 'Every figure sourced on the site.',
    rows: getRows()
  }, null, 2), 'application/json');
  const cls = 'inline-flex items-center gap-1.5 rounded-md border border-line px-2.5 py-1.5 text-[12.5px] text-ink transition-colors duration-150 hover:border-machine';
  return <div className="flex items-center gap-1.5" aria-label={`Download ${name}`} data-id="element-369" data-mp="3b7xfh4csmf0p">
      <button type="button" onClick={csv} className={cls} data-id="element-370" data-mp="uwnmzbw1029f">
        <DownloadIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-371" data-mp="pwj81qarnflb" /> CSV
      </button>
      <button type="button" onClick={json} className={cls} data-id="element-372" data-mp="pyvyysyi50ai">
        <DownloadIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-373" data-mp="ky7yzhsap945" /> JSON
      </button>
    </div>;
}